import { Share } from "@capacitor/share";
import { isNativePlatform } from "./platform";

export interface ShareContent {
  title?: string;
  text?: string;
  url?: string;
  files?: File[];
}

function isShareCancelled(error: unknown): boolean {
  if (error instanceof DOMException && error.name === "AbortError") {
    return true;
  }

  if (typeof error === "object" && error !== null && "message" in error) {
    const message = String((error as { message: unknown }).message).toLowerCase();
    return message.includes("cancel") || message.includes("abort");
  }

  return false;
}

export async function shareContent(content: ShareContent): Promise<boolean> {
  if (typeof window === "undefined") {
    return false;
  }

  if (isNativePlatform()) {
    try {
      await Share.share({
        title: content.title,
        text: content.text,
        url: content.url,
        dialogTitle: content.title ?? "Share",
      });
      return true;
    } catch (error) {
      if (isShareCancelled(error)) {
        return false;
      }
      throw error;
    }
  }

  if (
    typeof navigator.share === "function" &&
    typeof navigator.canShare === "function"
  ) {
    try {
      const payload: ShareData = {
        title: content.title,
        text: content.text,
        url: content.url,
      };

      if (content.files?.length && navigator.canShare({ files: content.files })) {
        payload.files = content.files;
      }

      await navigator.share(payload);
      return true;
    } catch (error) {
      if (isShareCancelled(error)) {
        return false;
      }
      throw error;
    }
  }

  return false;
}
